export enum ListWithDetailVariants {
  GRID = 'grid',
  LIST = 'list',
}
